var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock-time-three-outline",
    clipPath: "url(#clip0_709_12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.49984 9.16669C7.5165 9.16669 9.1665 7.51669 9.1665 5.50002C9.1665 3.48335 7.5165 1.83335 5.49984 1.83335C3.48317 1.83335 1.83317 3.48335 1.83317 5.50002C1.83317 7.51669 3.48317 9.16669 5.49984 9.16669ZM5.49984 0.916687C8.02067 0.916687 10.0832 2.97919 10.0832 5.50002C10.0832 8.02085 8.02067 10.0834 5.49984 10.0834C2.979 10.0834 0.916504 8.02085 0.916504 5.50002C0.916504 2.97919 2.979 0.916687 5.49984 0.916687ZM7.7915 5.27085V5.95835H5.0415V3.20835H5.729V5.27085H7.7915Z",
    fill: "#D98200"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.a766cc461d11cebca48132a1bc56b53f.svg";
export { ForwardRef as ReactComponent };